@if (activeWidgetMap?.size) {
  <div
    class="container"
    #widgetContainer
    cdkScrollable
    >
    @for (widget of activeWidgetMap | keyvalue: sort; track widget) {
      <jmkw-widget-wrapper
        [id]="widget.key"
        [widgetParams]="widget.value"
        class="widgets"
        >
      </jmkw-widget-wrapper>
    }
  </div>
}
